import React from "react";
import { Box, Grid } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import ColorSwatch from "../../Swatch";
import { gradients } from "../../../constants/background";

// Keyboard/AT parity (WL-024 / ISP-4200) — see ColorField for the rationale.
const activateOnKey = (fn) => (e) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    fn();
  }
};

const WallpaperField = ({ value, onChange }) => (
  <Grid container spacing={1} alignItems="center">
    <Grid item>
      <Box
        data-testid="wallpaper-none"
        role="button"
        tabIndex={0}
        aria-label="No wallpaper (neutral)"
        aria-pressed={!value}
        onClick={() => onChange("")}
        onKeyDown={activateOnKey(() => onChange(""))}
        sx={{
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          borderRadius: "50%",
          border: !value ? "1px solid #9B5AF8" : "1px solid transparent",
          "&:focus-visible": {
            outline: "2px solid #9B5AF8",
            outlineOffset: "2px",
          },
        }}
        title="No wallpaper (neutral)"
      >
        <BlockIcon sx={{ color: "#BBBBBB" }} />
      </Box>
    </Grid>
    {gradients.map((g, i) => (
      <Grid item key={g}>
        <Box
          data-testid={`wallpaper-swatch-${i}`}
          role="button"
          tabIndex={0}
          aria-label={`Wallpaper ${g}`}
          aria-pressed={value === g}
          onClick={() => onChange(g)}
          onKeyDown={activateOnKey(() => onChange(g))}
          sx={{
            cursor: "pointer",
            "&:focus-visible": {
              outline: "2px solid #9B5AF8",
              outlineOffset: "2px",
              borderRadius: "50%",
            },
          }}
        >
          <ColorSwatch color={g} borderColor={value === g && "#BBBBBB"} />
        </Box>
      </Grid>
    ))}
  </Grid>
);

export default WallpaperField;
